module.exports = __webpack_public_path__ + "img/modular_settlement_pickup_yellow@2x.8ff53291.png";